var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-layout" },
    [
      _c(
        "nav",
        {
          staticClass: "navbar app-layout__navbar",
          attrs: { role: "navigation", "aria-label": "main navigation" }
        },
        [
          _c("div", { staticClass: "navbar-brand" }, [
            _c("a", { staticClass: "logo", attrs: { href: _vm.rootAppUrl } }, [
              _c("img", {
                staticClass: "svg svg--large",
                attrs: { src: "/images/studios-logo.svg", alt: "Studios Logo" }
              })
            ])
          ]),
          _vm._v(" "),
          _vm.isLoggedIn
            ? _c(
                "div",
                {
                  staticClass: "navbar-menu",
                  class: { "is-active": _vm.isMenuOpen === true }
                },
                [
                  _c("div", { staticClass: "navbar-end" }, [
                    _c(
                      "a",
                      {
                        staticClass: "navbar-link is-arrowless is-hidden-touch",
                        attrs: { href: _vm.campaignsUrl }
                      },
                      [
                        _vm._v(
                          "\n                    My Campaigns\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "navbar-link is-arrowless is-hidden-touch",
                        attrs: { href: _vm.opportunitiesUrl }
                      },
                      [
                        _vm._v(
                          "\n                    Opportunities\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "navbar-item has-dropdown is-hoverable" },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "navbar-link is-arrowless navbar__settings is-hidden-touch"
                          },
                          [_c("gravatar")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "navbar-dropdown is-right" }, [
                          _c(
                            "a",
                            {
                              staticClass: "navbar-item",
                              attrs: { href: _vm.settingsUrl }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mr-3" },
                                [
                                  _c(
                                    "icon-base",
                                    {
                                      attrs: {
                                        "icon-name": "Profile",
                                        "icon-color": "fill--white",
                                        "has-circle": false,
                                        "view-box": "0 0 18 18"
                                      }
                                    },
                                    [_c("icon-profile")],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(
                                "\n                            My account\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "navbar-menu-divider" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "navbar-item",
                              attrs: { href: _vm.logoutUrl }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mr-3" },
                                [
                                  _c(
                                    "icon-base",
                                    {
                                      attrs: {
                                        "icon-name": "Logout",
                                        "icon-color": "fill--white",
                                        "has-circle": false,
                                        "view-box": "0 0 18 18"
                                      }
                                    },
                                    [_c("icon-logout")],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(
                                "\n                            Log out\n                        "
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoggedIn
            ? _c(
                "a",
                {
                  staticClass: "welcome-login is-hidden-mobile",
                  attrs: { href: _vm.loginUrl }
                },
                [_vm._v("Log In")]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-layout__scrollable" },
        [
          _c("MaintenanceBanner"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pb-footer app-layout__scrollable__body" },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer app-layout__scrollable__footer" }, [
            _c(
              "div",
              { staticClass: "columns is-gapless is-align-items-center" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "column is-flex is-justify-content-flex-start is-mobile-justify-content-center is-align-items-center footer__copyright"
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("span", { staticClass: "p-2" }, [
                      _vm._v("© " + _vm._s(_vm.currentYear) + " Traackr")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "footer__links" }, [
                    _c(
                      "a",
                      {
                        staticClass: "is-uppercase",
                        attrs: { href: _vm.supportEmail, target: "_blank" }
                      },
                      [_vm._v("Support")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "is-uppercase pl-6",
                        attrs: {
                          href: "https://help.traackr.com/creators/en/",
                          rel: "noopener noreferrer",
                          target: "_blank"
                        }
                      },
                      [_vm._v("Help")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "is-uppercase pl-6",
                        attrs: {
                          href: "https://www.traackr.com/tos-studios",
                          target: "_blank"
                        }
                      },
                      [_vm._v("Terms")]
                    )
                  ])
                ])
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoggedIn
        ? _c("action-menu-mobile", {
            attrs: {
              "action-left": { nav: _vm.campaignsUrl, text: "Campaigns" },
              "action-middle": {
                nav: _vm.opportunitiesUrl,
                text: "Opportunities"
              },
              "action-right": { nav: _vm.profileUrl, text: "My Account" }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "iconLeft",
                  fn: function() {
                    return [
                      _c(
                        "icon-base",
                        {
                          attrs: {
                            "icon-name": "Briefcase",
                            "icon-color": "fill--transparent",
                            "has-circle": false,
                            height: "24",
                            width: "24"
                          }
                        },
                        [_c("icon-briefcase")],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "iconMiddle",
                  fn: function() {
                    return [
                      _c(
                        "icon-base",
                        {
                          attrs: {
                            "icon-name": "Search",
                            "icon-color": "fill--transparent",
                            "has-circle": false,
                            height: "24",
                            width: "24"
                          }
                        },
                        [_c("icon-search")],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "iconRight",
                  fn: function() {
                    return [
                      _c(
                        "icon-base",
                        {
                          attrs: {
                            "icon-name": "Profile",
                            "icon-color": "fill--none",
                            "has-circle": false,
                            height: "24",
                            width: "24"
                          }
                        },
                        [_c("icon-profile")],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              4218564760
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "modal-portal", multiple: "" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "https://traackr.com" } }, [
      _c("img", {
        staticClass: "svg svg--medium",
        attrs: { src: "/images/studios-logo-simple.svg", alt: "Studios Logo" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }